import { useQuery } from '@tanstack/react-query'

import { queryKeys } from 'api/consts'

import { fetchUserCarousels } from './api'

import type { FetchUserCarouselsResponse } from './types'

export const useUserCarouselsQuery = <T = FetchUserCarouselsResponse>(
  { select }: { select: (data: FetchUserCarouselsResponse) => T },

) =>
  useQuery({
    queryFn: fetchUserCarousels,
    queryKey: [queryKeys.userCarousels],
    select,
  })
